import { field, date, children, writer, relation ,text} from '@nozbe/watermelondb/decorators';
import { POS_ORDERS_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class PosOrders extends Model {
    static table = POS_ORDERS_SCHEMA;

    static associations = {
        customer: { type: 'belongs_to', key: 'customer_id' },
        business: { type: 'belongs_to', key: 'business_id' },
        pos_order_lines: { type: 'has_many', foreignKey: 'pos_order_id' }
    }

    @field('amount_received') amount_received;
    @text('image_url') image_url;
    @field('amount') amount;
    @text('method') method;
    @field('count') count;
    @text('note') note;
    @field('tax') tax;

    @date('transacted_at') transacted_at;

    @relation('customer', 'customer_id') customer;
    @relation('business', 'business_id') business;
    @children('pos_order_lines') pos_order_lines;

    @writer async createPOSOrder(details) {
        this.collections.get(POS_ORDERS_SCHEMA).create(order => {
            order.invoice.set(this)
            order.stock.set(details.model)
            order.name = details.name
            order.quantity = details.quantity
            order.cost_price = details.cost_price
            order.selling_price = details.selling_price
        })
    }

}